import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar } = FiIcons;

const AmazonCard = ({ review, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.08 }}
      whileHover={{ y: -3, boxShadow: '0 0 28px rgba(255,153,0,0.2)' }}
      className="flex flex-col rounded-xl backdrop-blur-md border transition-all duration-300"
      style={{ background: 'rgba(255,255,255,0.06)', borderColor: 'rgba(212,175,55,0.35)' }}
    >
      {/* Badge */}
      <div className="px-5 pt-5 pb-0">
        <span
          className="inline-flex items-center gap-1.5 font-lexend text-[8px] tracking-wider uppercase px-3 py-1 rounded-full"
          style={{ background: '#FF9900', color: '#111', fontWeight: 700 }}
        >
          <svg width="9" height="9" viewBox="0 0 24 24" fill="#111" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575z"/>
          </svg>
          Amazon Verified Purchase
        </span>
      </div>

      <div className="flex flex-col flex-grow px-5 pb-5 pt-3">
        {/* Stars + Country */}
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-0.5">
            {[...Array(5)].map((_, i) => (
              <SafeIcon key={i} icon={FiStar} className="w-3 h-3" style={{ fill: '#FF9900', stroke: 'none', color: '#FF9900' }} />
            ))}
            <span className="font-lexend text-[10px] ml-1" style={{ color: '#FF9900' }}>5.0</span>
          </div>
          <span className="font-lexend text-[9px] text-cream/40">{review.country}</span>
        </div>

        {/* Title */}
        <h4 className="font-michroma text-[12px] text-gold mb-2 leading-snug">{review.title}</h4>

        {/* Quote */}
        <blockquote className="flex-grow mb-4">
          <p className="font-lexend text-[12px] leading-relaxed text-cream/85">
            "{review.quote}"
          </p>
        </blockquote>

        {/* Reviewer + Date */}
        <div className="border-t pt-3" style={{ borderColor: 'rgba(212,175,55,0.15)' }}>
          <p className="font-michroma text-gold/80 text-[10px] tracking-wider uppercase">{review.reviewer}</p>
          <p className="font-lexend text-cream/40 text-[9px] mt-0.5">
            Reviewed in {review.country} · {review.date}
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default AmazonCard;